import { IconButtonGroup } from '@shared/IconButtonGroup'
import { Col, Row } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AsanIco, DeleteIco, EditIco } from '@modules/CustomIcons'
import { useWatch } from 'react-hook-form'
import useSelectedRowKey from '@shared/hooks/useSelectedRowKey'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { secureLocalStorageGet } from '../../../../../../app/helpers'
import { StatusType } from '../../constants/fieldValues.constant'
import { arrayBufferToBase64, AsanSigning } from '@shared/AsanSigning'
import { asanSigningAdocFile } from '../../../../../services/IbSigning/asan'
import useAsanAdocDownloader from '@shared/AsanSigning/useAsanAdocDownloader'
import DeleteOrderForm from '../../entities/OrderDetailsModal/blocks/OrderDetailModalFooter/DeleteOrderForm'
import { IconButtonItemProps } from '@shared/IconButtonGroup/types'
import { useHistory } from 'react-router-dom'
import {
  businessCardOrderApi,
  useBusinessCardListQuery,
  useBusinessCardOrderDetailMutation,
  useUpdateBusinessCardOrderStatusMutation,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import { useDispatch } from 'react-redux'

function BusinessCardFooterBar() {
  const { t } = useTranslation()
  const { downloadAdocFile } = useAsanAdocDownloader()
  const history = useHistory()
  const dispatch = useDispatch()

  const role = secureLocalStorageGet('rol')
  const status = useWatch({ name: 'status' })
  const selectedRowKeys = useSelectedRowKey()
  const originalArgs = useAppSelector(
    (state) => state.api.queries.fetchBusinessCardList?.originalArgs
  )
  const { data: businessCardList } = useBusinessCardListQuery(originalArgs, {
    skip: !originalArgs,
  })

  const [updateOrderStatus, { status: uosStatus, isSuccess: isOsSuccess, reset, error }] =
    useUpdateBusinessCardOrderStatusMutation()

  const [fetchOrderDetails] = useBusinessCardOrderDetailMutation({
    fixedCacheKey: 'businessCardOrderDetail',
  })

  const disabledAdocAndFatcha = ![StatusType.CLOSED].includes(
    businessCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.businessCardTable?.[0]
    )?.status
  )

  const disabledSignBtn =
    businessCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.businessCardTable?.[0]
    )?.status === StatusType.PENDING_SIGNER

  const disabledEditAndDeleteBtn = !(
    businessCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.businessCardTable?.[0]
    )?.status === StatusType.PENDING_SIGNER
  )

  const downloadAdoc = async () => {
    downloadAdocFile(
      asanSigningAdocFile,
      businessCardList?.orderList?.find(
        (item) => item.orderNo === selectedRowKeys.businessCardTable?.[0]
      )?.transactionId,
      `${selectedRowKeys.businessCardTable[0]}.adoc`
    )
  }

  const footerBtnsTransferFooter = [
    // {
    //   icon: <DownloadFatcaFile disabledCanditation={disabledAdocAndFatcha} />,
    //   title: t('orders.salaryCardOrder.constants.fatcaDownload'),
    //   key: 'adoc',
    //   visible: false,
    //   onClick: downloadFatcha,
    //   disabled: disabledAdocAndFatcha,
    // },
    {
      icon: <AsanIco />,
      title: t('transfers.downloadAdoc'),
      key: 'adoc',
      visible: false,
      onClick: downloadAdoc,
      disabled: disabledAdocAndFatcha,
    },
  ]

  const footerActionBtns: IconButtonItemProps[] = [
    {
      key: 'edit',
      icon: <EditIco />,
      title: t('transfers.edit2'),
      visible: false,
      onClick: () => {
        history.push(
          `/orders/business-card/update/${selectedRowKeys.businessCardTable?.[0]}`
        )
      },
      disabled: disabledEditAndDeleteBtn,
    },
    {
      key: 'delete',
      icon: <DeleteIco />,
      title: t('transfers.delete'),
      modal: {
        footer: null,
        title: t('orders.salaryCardOrder.constants.deleteReason'),
        width: 600,
        bodyStyle: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' },
        modalContent: (
          <DeleteOrderForm
            orderNo={selectedRowKeys.businessCardTable?.[0] as string}
          />
        ),
      },
      visible: false,
      onClick: () => {},
      disabled: disabledEditAndDeleteBtn,
    },
  ]

  const onSigning = async () => {
    if (selectedRowKeys?.businessCardTable?.[0]) {
      const detailData = await fetchOrderDetails({
        orderNo: selectedRowKeys?.businessCardTable?.[0],
      }).unwrap()

      return {
        files: [
          {
            name: `${selectedRowKeys.businessCardTable[0]}.json`,
            mimeType: 'application/json',
            encodedBytes: arrayBufferToBase64(detailData),
          },
        ],
      }
    }
  }

  return (
    <>
      <Row align={'middle'}>
        <Col span={8}>
          {role === 2 && status === StatusType.FOR_MUST_BE_SIGNED && (
            <AsanSigning
              docType="BCO"
              asanKey="asanSignOutDetail"
              handleSigning={onSigning}
              checkSignCallback={() => disabledSignBtn}
              status={uosStatus}
              message={error?.data}
              onComplete={(data) => {
                updateOrderStatus({
                  orderNo: selectedRowKeys.businessCardTable?.[0],
                  ...data,
                })
              }}
              afterCloseFn={() => {
                if (isOsSuccess) {
                  reset()
                  dispatch(
                    businessCardOrderApi.util.invalidateTags([
                      'BusinessCardStatusList'
                    ])
                  )
                }
              }}
            />
          )}
        </Col>
        <Col span={8} offset={8}>
          <Row justify="end" style={{ gap: 20 }}>
            <IconButtonGroup buttons={footerActionBtns} />
            <IconButtonGroup buttons={footerBtnsTransferFooter} />
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default BusinessCardFooterBar
